import { useContext } from 'react'

import GlossaryScopeContext from '@providers/glossaryScopeProvider'

export default function useGlossaryScope() {
  const { foundEntries, updateFoundEntries } = useContext(GlossaryScopeContext)

  return { foundEntries, updateFoundEntries }
}
